
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyBarrelFlag as ObiBuoyBarrelFlagElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-barrel-flag.js';
 
 
 

 
 export const ObiBuoyBarrelFlag = createComponent({
   react: React,
   tagName: 'obi-buoy-barrel-flag',
   elementClass: ObiBuoyBarrelFlagElement,
   events: {
     
   }
  });
 
 